const FrameMessages = {
  setVisible: 'setVisible',
  setHidden: 'setHidden',
  requestHide: 'requestHide',
  allowDismiss: 'allowDismiss',
  setRedirectState: 'setRedirectState',
};

export default FrameMessages;
